import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import ChannelItem from "@/components/ChannelItem.vue";
import Loading from "@/components/Loading.vue";
import { Channel } from "@/models/channel";
import { Consts } from '@/consts';
import { GraphApiUtils } from '@/utils/graphApiUtils';
import { Channels } from '@/models/channels';
import { Plans } from '@/models/plans';
import { Plan } from '@/models/plan';

@Component({
	components: {
		ChannelItem,
		Loading
	}
})
export default class UserChannelsHome extends Vue {
	@Prop() public groupName!: string;
	@Prop() public channels!: Channels;
	@Prop() public plans!: Plans;
	@Prop() public isLoadingChannels!: boolean;
	private subTitle: string = "カリキュラム一覧";
	// イベント名はケバブケース
	@Emit("click-channel-item")
	public clickChannelItem(channelId: string) { }

	@Emit("click-title")
	public clickTitle(title: string) { }


	public async created(): Promise<void> {
		// アクセストークンが有効でない場合はルートに遷移。
		if (!await GraphApiUtils.isValidAccessToken(Vue.$accessTokenInfo)) {
			this.$router.push(Consts.PATH_USER);
			return;
		}
		// TODO ChannelsではなくPlansだけでいい気がする
	}

	public async mounted(): Promise<void> {
	}

	public async updated(): Promise<void> {
	}

	public onChannelItemClick(channelId: string): void {
		this.clickChannelItem(channelId);
	}

	private getPlanId(channelId: string): string {
		if (this.channels === undefined) {
			return '';
		}
		const channel: Channel | null = this.channels.get(channelId);
		if (channel === null) {
			return '';
		}
		const plan: Plan | null = this.plans.getByTitle(channel.displayName);
		if (plan === null) {
			return '';
		}
		return plan.id;
	}

	private disabled(channelId: string): boolean {
		return false;
	}
}
